
import request from '../utils/request'
const { swSewagePath } = window.globalConfig;
export default class InspectionApi {
  /**
   * 查询巡检模版 分页
   * @param params
   * @returns {*|Promise<*>}
   */
  static query = (params) => {
    return request.post(`/${swSewagePath}/api/patroltemplate/pageList`, params)
  }
  /**
   * 创建巡检模版
   * @param params
   * @returns {*|Promise<*>}
   */
  static add = (params, config) => {
    return request.post(`/${swSewagePath}/api/patrolTaskGroup/add`, params)
  }
  /**
   * 删除巡检模版
   * @param params
   * @returns {*|Promise<*>}
   */
  static delete = (id) => {
    return request.appid(`/${swSewagePath}/api/patroltemplate/del?id=${id}`)
  }
  /**
 * 更新巡检模版状态
 * @param params
 * @returns {*|Promise<*>}
 */
  static updateStatus = (params) => {
    return request.post(`/${swSewagePath}/api/patroltemplate/updateStatus`, params)
  }
  /**
   * 查询模版详情
   * @param params
   * @returns {*|Promise<*>}
   */
  static getInfo = (params) => {
    return request.get(`/${swSewagePath}/api/patroltemplate/getInfo`, params)
  }
  /**
   * 查询场站的巡检模版
   * @param params
   * @returns {*|Promise<*>}
   */
  static getPatrolTemplateByStation = (params) => {
    return request.post(`/${swSewagePath}/api/patroltemplate/getPatrolTemplateByStation`, params)
  }
  /*********************** 巡检计划 b **************************/

  static planAdd = (params) => {
    return request.post(`/${swSewagePath}/api/patrolplan/add`, params)
  }
  static planDel = (id) => {
    return request.appid(`/${swSewagePath}/api/patrolplan/del?id=${id}`)
  }
  static planInfo = (id) => {
    return request.appid(`/${swSewagePath}/api/patrolplan/getInfo?id=${id}`)
  }
  static planQuery = (params) => {
    return request.post(`/${swSewagePath}/api/patrolplan/pageList`, params)
  }
  static planStatus = (params) => {
    return request.post(`/${swSewagePath}/api/patrolplan/updateStatus`, params)
  }
  /*********************** 巡检计划 e **************************/

  /*********************** 巡检项 b **************************/

  static getPatrolItems = (id, type) => {
    return request.appid(`/${swSewagePath}/api/patrolitem/getPatrolItems?stationId=${id}&type=${type}`)
  }
  static selectPatrolItemByStation = (id) => {
    return request.appid(`/${swSewagePath}/api/patrolitem/selectPatrolItemByStation?stationId=${id}`)
  }
  static selectPatrolItemsByParams = (params) => {
    return request.post(`/${swSewagePath}/api/patrolitem/selectPatrolItemsByParams`, params)
  }
  /*********************** 巡检项 e **************************/

  /*********************** 巡检任务 b **************************/
  // 巡检任务列表
  static taskQuery = (params) => {
    return request.post(`/${swSewagePath}/api/patroltask/pageList`, params)
  }
  // 巡检任务详情
  static getPatrolTaskInfo = (params) => {
    return request.post(`/${swSewagePath}/api/patroltask/getPatrolTaskInfo`, params)
  }
  /*********************** 巡检任务 e **************************/


  /*********************** 缺陷 b **************************/
  // 列表
  static defectQuery = (params) => {
    return request.post(`/${swSewagePath}/api/patroldefect/pageList`, params)
  }
  // 关闭缺陷
  static closeDefectOrder = (id) => {
    return request.appid(`/${swSewagePath}/api/patroldefect/closeDefectOrder?id=${id}`)
  }
  // 缺陷转工单
  static turnToWorkOrder = (params) => {
    return request.post(`/${swSewagePath}/api/patroldefect/turnToWorkOrder`, params)
  }
  /*********************** 缺陷 e **************************/


  /*********************** 工单 b **************************/
  // 工单列表
  static orderQuery = (params) => {
    return request.post(`/${swSewagePath}/api/patrolWorkOrder/pageList`, params)
  }
  static orderStatus = (params) => {
    return request.post(`/${swSewagePath}/api/patrolWorkOrder/updateStatus`, params)
  }
  /*********************** 工单 e **************************/
}
